import React from 'react';
import { useTheme } from 'styled-components';
import { IconProps } from 'components/icons/types';

export const Wallet = ({ className }: IconProps) => {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 44 44"
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="22" fill={theme.w.colors.primary.main} />
      <path
        d="M31.0911 12.8428H13.7938C13.2541 12.8428 12.7365 13.0572 12.3548 13.4388C11.9732 13.8204 11.7588 14.338 11.7588 14.8778V29.1226C11.7588 29.6623 11.9732 30.1799 12.3548 30.5616C12.7365 30.9432 13.2541 31.1576 13.7938 31.1576H30.0736C30.6133 31.1576 31.1309 30.9432 31.5126 30.5616C31.8942 30.1799 32.1086 29.6623 32.1086 29.1226V17.9302C32.1086 17.6604 32.0014 17.4016 31.8106 17.2107C31.6198 17.0199 31.3609 16.9127 31.0911 16.9127H14.8113C14.5414 16.9127 14.2826 16.8055 14.0918 16.6147C13.901 16.4239 13.7938 16.1651 13.7938 15.8952C13.7938 15.6254 13.901 15.3666 14.0918 15.1758C14.2826 14.985 14.5414 14.8778 14.8113 14.8778H32.1086V13.8603C32.1086 13.5904 32.0014 13.3316 31.8106 13.1408C31.6198 12.95 31.3609 12.8428 31.0911 12.8428ZM28.5474 22.5089C28.8492 22.5089 29.1443 22.5984 29.3953 22.7661C29.6463 22.9338 29.8419 23.1722 29.9574 23.4511C30.0729 23.73 30.1032 24.0369 30.0443 24.3329C29.9854 24.629 29.84 24.9009 29.6266 25.1144C29.4131 25.3278 29.1412 25.4732 28.8451 25.5321C28.5491 25.591 28.2422 25.5607 27.9633 25.4452C27.6844 25.3297 27.4461 25.1341 27.2784 24.8831C27.1106 24.6321 27.0211 24.337 27.0211 24.0352C27.0211 23.6304 27.1819 23.2422 27.4682 22.9559C27.7544 22.6697 28.1426 22.5089 28.5474 22.5089Z"
        fill={theme.w.colors.button.text}
      />
    </svg>
  );
};
